import { useRouter } from 'next/router'

import { useFormContext, useWatch } from 'react-hook-form'

import usePaginationForm from 'app/hooks/usePaginationForm'
import { useGetUserReviews } from 'app/services/Query/user/user.query'
import useAuthStore, { getAuthUserSlug } from 'app/store/auth.store'
import { REVIEWS_PARAMS_TYPE } from 'app/utils/constants/status.constants'

interface UseReviewListProps {
  userId?: number
  slug: string
}

export const useReviewList = ({ slug, userId }: UseReviewListProps) => {
  const { isFallback } = useRouter()
  const methods = useFormContext()
  const authUserSlug = useAuthStore(getAuthUserSlug)

  const { receive, p } = useWatch({ control: methods.control })

  const { page: paginationPage, setPage } = usePaginationForm({
    control: methods?.control,
    ...(!!slug && { setValue: methods?.setValue })
  })

  const params = {
    [REVIEWS_PARAMS_TYPE[receive || 'seller']]: userId,
    page: p === 1 ? undefined : p
  }

  const { data, isFetched, isFetchedAfterMount, isFetching } =
    useGetUserReviews({
      params,
      options: {
        enabled: !!userId && !!receive,
        placeholderData: {
          reviews: [
            { id: '1', isLoading: true },
            { id: '2', isLoading: true },
            { id: '3', isLoading: true },
            { id: '4', isLoading: true }
          ],
          pagy: {}
        } as PaginationUserReviewsModel
      }
    })

  const { reviews, pagy } = data || ({} as PaginationUserReviewsModel)

  const pages = pagy?.pages || 1
  const showPagination = isFetched && pages > 1

  const isPageLoading = isFallback || (!isFetchedAfterMount && isFetching)

  const isEmpty = !reviews?.length && !isFetching

  const showActionCards = slug === authUserSlug

  return {
    reviews,
    pagy,
    pages,
    showPagination,
    isPageLoading,
    isEmpty,
    showActionCards,
    paginationPage,
    setPage
  }
}
